import axios from "axios";
import AuthServiceInstance from "./auth-service";

const MAX_TOKEN_REFRESH_ATTEMPTS = 3;

const getRetryCount = () => {
  const count = sessionStorage.getItem('tokenRefreshRetryCount');
  return count ? parseInt(count) : 0;
};

const setRetryCount = (count) => {
  sessionStorage.setItem('tokenRefreshRetryCount', count.toString());
};

const resetRetryCount = () => {
  sessionStorage.removeItem('tokenRefreshRetryCount');
};

const apiWrapper = async (url, method, body = null, headers = {}) => {
  try {
    const options = {
      method,
      url: url,
      headers: headers,
      data: body,
    };
    // console.log("Request URL:", url);
    // console.log("Request Options:", options);
    const res = await axios(options);
    
    if (res?.data?.status?.code === 401) {
      const currentRetryCount = getRetryCount();
      // console.log("Current retry count:", currentRetryCount);

      if (currentRetryCount >= MAX_TOKEN_REFRESH_ATTEMPTS) {
        console.error("Max token refresh attempts reached, logging out...");
        sessionStorage.clear();
        handleTokenRefreshFailure();
        return null;
      }

      setRetryCount(currentRetryCount + 1);
      const newTokenRes = await AuthServiceInstance.tokenRegenerate();
      if (newTokenRes.status.success) {
        const updatedHeaders = {
          ...headers,
          cap_authorization: sessionStorage.getItem("token")
        };
        
        const retryOptions = {
          method,
          url: url,
          headers: updatedHeaders,
          data: body,
        };
        const retryRes = await axios(retryOptions);
        resetRetryCount(); // Reset on successful retry
        return retryRes.data;
      } else {
        console.error("Token refresh failed, logging out...");
        resetRetryCount();
        handleTokenRefreshFailure();
        return null;
      }
    }
    resetRetryCount(); // Reset on successful request
    return res.data;
  } catch (error) {
    resetRetryCount(); // Reset on non-401 error
    console.error("API call failed", error);
    throw error;
  }
};
const handleTokenRefreshFailure = () => {
  // Redirect user to login page
  window.location.href = "#/loginpage";
};

export default apiWrapper;
